import { render, staticRenderFns } from "./setTalk.vue?vue&type=template&id=00478f4a&scoped=true&"
import script from "./setTalk.vue?vue&type=script&lang=js&"
export * from "./setTalk.vue?vue&type=script&lang=js&"
import style0 from "./setTalk.vue?vue&type=style&index=0&id=00478f4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00478f4a",
  null
  
)

export default component.exports